export default {
  shopListData: (state) => state.shopListData,
  favoriteShopListData: (state) => state.favoriteShopListData,
  shopDetail: (state) => state.shopDetail,
  prefectures: (state) => state.prefectures,
  municipalities: (state) => state.municipalities,
  genres: (state) => state.genres,
  couponsData: (state) => state.couponsData,
  favoriteCouponsData: (state) => state.favoriteCouponsData,
  photosData: (state) => state.photosData,
  favoritePhotosData: (state) => state.favoritePhotosData,
  menuData: (state) => state.menuData,
  couponDetail: (state) => state.couponDetail,
  galleryDetail: (state) => state.galleryDetail,
  count: (state) => state.count,
  isErrorCouponDetail: (state) => state.isErrorCouponDetail,
  parentShopDetail: (state) => state.parentShopDetail,
  parentShopId: (state) => state.parentShopId,
  newPoint: (state) => state.newPoint,
  shopPrefectures: (state) => state.shopPrefectures,
  shopMunicipalities: (state) => state.shopMunicipalities,
  barcodeQr: (state) => state.barcodeQr,
};
